export const paginateItems = (items, itemIds) => {
  return items.filter((item) => itemIds.includes(item.id));
};
